module.exports = __webpack_public_path__ + "img/plus-primary.46df4530.svg";